import Vue from "vue";
import Router from "vue-router";
import NotDefined from "@views/NotDefined";
import Index from "@views/Index";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        title: "首页",
        keepAlive: true
      },
      component: Index
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false
      },
      component: NotDefined
    },
    {
      path: "/news",
      name: "News",
      component: () => import("@views/News.vue")
    },
    {
      path: "/news-detail",
      // path: "/news-detail/:id",
      name: "NewsDetail",
      component: () => import("@views/NewsDetail.vue")
    },
    {
      path: "/story",
      name: "Story",
      component: () => import("@views/Story.vue")
    },
    {
      path: "/character",
      name: "Character",
      component: () => import("@views/Character.vue")
    },
    {
      // path: "/character-detail/:id/:rarity?/:property?",
      path: "/character-detail",
      name: "CharacterDetail",
      component: () => import("@views/CharacterDetail.vue")
    },
    {
      path: "/gamesystem",
      name: "Gamesystem",
      component: () => import("@views/Gamesystem.vue")
    },
    {
      path: "/device",
      name: "Device",
      component: () => import("@views/Device.vue")
    },
    {
      path: "/faq",
      name: "Faq",
      component: () => import("@views/Faq.vue")
    },
    {
      path: "/downloads",
      name: "Downloads",
      component: () => import("@views/Downloads.vue")
    },
    {
      path: "/download",
      name: "Download",
      component: () => import("@views/download.vue"),
      meta: {
        title: "下载",
        hidden: true
      }
    },
    {
      path: "/movie",
      name: "Movie",
      component: () => import("@views/Movie.vue")
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  window.$(".loading-wrap").fadeIn();

  if (window.isMobile.any) {
    window.$(".nav-wrap").fadeOut(150);
  } else {
    if (to.name === "home") {
      window.$(".nav-wrap").fadeOut(150);
      window.$(".header-bar__download").addClass("top0");
    } else {
      window.$(".header-bar__download").removeClass("top0");
    }
  }
  next();
});

router.afterEach(() => {
  window.$(".loading-wrap").fadeOut();
});

export default router;
